import { render, staticRenderFns } from "./EditRoles.admin.vue?vue&type=template&id=071bab86&scoped=true&lang=html&"
import script from "./EditRoles.admin.vue?vue&type=script&lang=js&"
export * from "./EditRoles.admin.vue?vue&type=script&lang=js&"
import style0 from "./EditRoles.admin.vue?vue&type=style&index=0&id=071bab86&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bab86",
  null
  
)

export default component.exports